var map = {
	"./CompoundScopeGraphicSlices/CompScope_BASE.png": "a9f0",
	"./CompoundScopeGraphicSlices/CompScope_Bright_01.png": "73ea",
	"./CompoundScopeGraphicSlices/CompScope_Bright_02.png": "a3a1",
	"./CompoundScopeGraphicSlices/CompScope_Bright_03.png": "b957",
	"./CompoundScopeGraphicSlices/CompScope_Bright_04.png": "91f5",
	"./CompoundScopeGraphicSlices/CompScope_Bright_05.png": "8d01",
	"./CompoundScopeGraphicSlices/CompScope_Bright_06.png": "8d63",
	"./CompoundScopeGraphicSlices/CompScope_Bright_07.png": "bffb",
	"./CompoundScopeGraphicSlices/CompScope_Bright_08.png": "585a",
	"./CompoundScopeGraphicSlices/CompScope_Bright_09.png": "b91a",
	"./CompoundScopeGraphicSlices/CompScope_Bright_10.png": "7c0e",
	"./CompoundScopeGraphicSlices/CompScope_Mag_1_Focus_0.png": "1595",
	"./CompoundScopeGraphicSlices/CompScope_Mag_1_Focus_1.png": "bd23",
	"./CompoundScopeGraphicSlices/CompScope_Mag_1_Focus_2.png": "4fd1",
	"./CompoundScopeGraphicSlices/CompScope_Mag_2_Focus_0.png": "a882",
	"./CompoundScopeGraphicSlices/CompScope_Mag_2_Focus_1.png": "e846",
	"./CompoundScopeGraphicSlices/CompScope_Mag_2_Focus_2.png": "f976",
	"./CompoundScopeGraphicSlices/CompScope_Mag_3_Focus_0.png": "dd3d",
	"./CompoundScopeGraphicSlices/CompScope_Mag_3_Focus_1.png": "1113",
	"./CompoundScopeGraphicSlices/CompScope_Mag_3_Focus_2.png": "7254",
	"./CompoundScopeGraphicSlices/CompScope_Mag_4_Focus_0.png": "3f63",
	"./CompoundScopeGraphicSlices/CompScope_Mag_4_Focus_1.png": "0656",
	"./CompoundScopeGraphicSlices/CompScope_Mag_4_Focus_2.png": "0b16",
	"./CompoundScopeGraphicSlices/CompScope_Space_00.png": "2fb5",
	"./CompoundScopeGraphicSlices/CompScope_Space_01.png": "8f10",
	"./CompoundScopeGraphicSlices/CompScope_Space_02.png": "e3b2",
	"./CompoundScopeGraphicSlices/CompScope_Space_03.png": "af9a",
	"./CompoundScopeGraphicSlices/CompScope_Space_04.png": "c933",
	"./CompoundScopeGraphicSlices/CompScope_Space_05.png": "3fa7",
	"./CompoundScopeGraphicSlices/CompScope_Space_06.png": "beed",
	"./CompoundScopeGraphicSlices/CompScope_Space_07.png": "e9ce",
	"./CompoundScopeGraphicSlices/CompScope_Space_08.png": "e210",
	"./CompoundScopeGraphicSlices/CompScope_Space_09.png": "1275",
	"./CompoundScopeGraphicSlices/CompScope_Space_10.png": "c1fc",
	"./base/Microscopy_Base": "6827",
	"./base/Microscopy_Base.json": "6827",
	"./base/Microscopy_Base.png": "9b8a",
	"./base/Microscopy_Base.tps": "0829",
	"./base/Microsopy_background.jpg": "b9d6",
	"./fonts/benchnine-v9-latin/benchnine-v9-latin-regular.eot": "b8bf",
	"./fonts/benchnine-v9-latin/benchnine-v9-latin-regular.svg": "a5d3",
	"./fonts/benchnine-v9-latin/benchnine-v9-latin-regular.ttf": "c72a",
	"./fonts/benchnine-v9-latin/benchnine-v9-latin-regular.woff": "d79a",
	"./fonts/benchnine-v9-latin/benchnine-v9-latin-regular.woff2": "ff38",
	"./fonts/mdi/Material-Regular.woff2": "2914",
	"./fonts/mdi/MaterialIcons-Regular.codepoints": "27e1",
	"./fonts/mdi/MaterialIcons-Regular.ttf": "f8e9",
	"./fonts/mdi/MaterialIconsOutlined-Regular.codepoints": "5dcf",
	"./fonts/mdi/MaterialIconsOutlined-Regular.otf": "45e8",
	"./fonts/mdi/MaterialIconsRound-Regular.codepoints": "9975",
	"./fonts/mdi/MaterialIconsRound-Regular.otf": "ca0c",
	"./fonts/mdi/MaterialIconsSharp-Regular.codepoints": "6ba2",
	"./fonts/mdi/MaterialIconsSharp-Regular.otf": "63db",
	"./fonts/mdi/MaterialIconsTwoTone-Regular.codepoints": "6fc3",
	"./fonts/mdi/MaterialIconsTwoTone-Regular.otf": "d5bc",
	"./fonts/mdi/README.md": "9733",
	"./fonts/open-sans-condensed-bold/OpenSansCondensed-Bold.ttf": "070b",
	"./fonts/open-sans-condensed/OpenSansCondensed-Bold.ttf": "fab0",
	"./fonts/open-sans-condensed/OpenSansCondensed-Light.ttf": "ae73",
	"./fonts/open-sans-v18-latin/open-sans-v18-latin-regular.eot": "f111",
	"./fonts/open-sans-v18-latin/open-sans-v18-latin-regular.svg": "d877",
	"./fonts/open-sans-v18-latin/open-sans-v18-latin-regular.ttf": "8bf5",
	"./fonts/open-sans-v18-latin/open-sans-v18-latin-regular.woff": "4a7e",
	"./fonts/open-sans-v18-latin/open-sans-v18-latin-regular.woff2": "0eb5",
	"./fonts/open-sans/Apache License.txt": "1c48",
	"./fonts/open-sans/OpenSans-Bold.ttf": "638c",
	"./fonts/open-sans/OpenSans-BoldItalic.ttf": "7843",
	"./fonts/open-sans/OpenSans-Italic.ttf": "5303",
	"./fonts/open-sans/OpenSans-LightItalic.ttf": "ef02",
	"./fonts/open-sans/OpenSans-Regular.ttf": "6cd4",
	"./general_lab_icons/BL_lab_bar_logo.svg": "c0a4",
	"./general_lab_icons/CaretDown.svg": "9535",
	"./general_lab_icons/CaretUp.svg": "5334",
	"./general_lab_icons/Close.svg": "71be",
	"./general_lab_icons/Ellipsis.svg": "4e79",
	"./general_lab_icons/Microscopy32.png": "9c64",
	"./general_lab_icons/Search.svg": "8a55",
	"./general_lab_icons/export_pdf_arrow-24px.svg": "0449",
	"./general_lab_icons/favicon.ico": "2e697",
	"./general_lab_icons/import_pdf_arrow-24px.svg": "594c",
	"./json/BenchConfig": "093f",
	"./json/BenchConfig.json": "093f",
	"./json/BiologyLabTexts": "e343",
	"./json/BiologyLabTexts.json": "e343",
	"./json/BiologyLabTextsEs": "cb8a",
	"./json/BiologyLabTextsEs.json": "cb8a",
	"./json/TextStyleConfig": "e134",
	"./json/TextStyleConfig.json": "e134",
	"./live_data_icons/Clear-24px.svg": "3d20",
	"./live_data_icons/SaveToLabBook-24px.svg": "c433",
	"./live_data_icons/SliderBar_106px.svg": "d8cd",
	"./live_data_icons/show_labels_Blue_24dp.svg": "51ef",
	"./live_data_icons/show_labels_White_24dp.svg": "e108",
	"./live_data_icons/zoom_in-24px.svg": "d9ed",
	"./live_data_icons/zoom_out-24px.svg": "ff75",
	"./localization/common-lang-en": "4d37",
	"./localization/common-lang-en.json": "4d37",
	"./localization/common-lang-es": "903d",
	"./localization/common-lang-es.json": "903d",
	"./localization/languages": "90a9",
	"./localization/languages.js": "90a9",
	"./media/Magnification_Poster_OpenFull.png": "544b",
	"./media/interface/category_10.png": "f7d2",
	"./media/interface/category_11.png": "6b3fc",
	"./media/interface/category_12.png": "8c16",
	"./media/interface/category_13.png": "3be6",
	"./media/interface/category_14.png": "608c",
	"./media/interface/category_15.png": "15af",
	"./media/interface/category_16.png": "1ee0",
	"./media/interface/category_17.png": "6c9d",
	"./media/interface/category_18.png": "404d",
	"./media/interface/category_19.png": "f77c",
	"./media/interface/category_20.png": "0c94",
	"./media/interface/category_21.png": "5f45",
	"./media/interface/category_22.png": "39ad",
	"./media/interface/category_23.png": "42d4",
	"./media/interface/category_24.png": "134b",
	"./media/interface/category_25.png": "27b3",
	"./media/interface/category_26.png": "196e",
	"./media/interface/category_27.png": "f611",
	"./media/interface/category_28.png": "cce9",
	"./media/interface/category_29.png": "8cec",
	"./media/interface/category_30.png": "4904",
	"./media/interface/category_31.png": "8a83",
	"./media/interface/category_32.png": "0cfe",
	"./media/interface/category_33.png": "db92",
	"./media/interface/category_34.png": "2ca5",
	"./media/interface/category_35.png": "014f",
	"./media/interface/category_36.png": "da4a",
	"./media/interface/category_37.png": "c178",
	"./media/interface/category_38.png": "2766",
	"./media/interface/category_39.png": "b377",
	"./media/interface/category_40.png": "e50c",
	"./media/interface/category_41.png": "f27f",
	"./media/interface/category_42.png": "8668",
	"./media/interface/category_7.png": "aaff",
	"./media/interface/category_8.png": "5b65",
	"./media/interface/category_9.png": "c2f3",
	"./microscopeConnectors/FieldScope.png": "9a60",
	"./microscopeConnectors/MicroscopesDissectingCompound.png": "4d1b",
	"./microscopeConnectors/SEM.png": "46fc",
	"./microscopeConnectors/TEM.png": "f98f",
	"./nav_tray_icons/Clear Lab_Down.svg": "6292",
	"./nav_tray_icons/Clear Lab_Over.svg": "8a0f",
	"./nav_tray_icons/Clear_Lab_Up.svg": "a730",
	"./nav_tray_icons/Lab Book Icon_Down.svg": "25ca",
	"./nav_tray_icons/Lab Book Icon_Over.svg": "5d6a",
	"./nav_tray_icons/Lab_Book_Icon_Big_Text.svg": "cc6a",
	"./nav_tray_icons/Lab_Book_Icon_Bold.svg": "3990",
	"./nav_tray_icons/Lab_Book_Icon_Copy.svg": "4a8e",
	"./nav_tray_icons/Lab_Book_Icon_Export_PDF.svg": "9ad5",
	"./nav_tray_icons/Lab_Book_Icon_Italic.svg": "9ec0",
	"./nav_tray_icons/Lab_Book_Icon_Paste.svg": "f4bb",
	"./nav_tray_icons/Lab_Book_Icon_Send.svg": "c087",
	"./nav_tray_icons/Lab_Book_Icon_Small_Text.svg": "4905",
	"./nav_tray_icons/Lab_Book_Icon_Sub_Script.svg": "92dc",
	"./nav_tray_icons/Lab_Book_Icon_Super_Script.svg": "f3a1",
	"./nav_tray_icons/Lab_Book_Icon_Underline.svg": "7b1c",
	"./nav_tray_icons/Lab_Book_Icon_Up.svg": "ad53",
	"./nav_tray_icons/Live Data Icon_Down.svg": "979d",
	"./nav_tray_icons/Live Data Icon_Over.svg": "12a9",
	"./nav_tray_icons/Live_Data_Icon_Up.svg": "7a71",
	"./nav_tray_icons/Presets Icon_Down.svg": "d635",
	"./nav_tray_icons/Presets Icon_Over.svg": "08ef",
	"./nav_tray_icons/Presets_Icon_Up.svg": "31b7",
	"./nav_tray_icons/Procedures_Icon_Down.svg": "5c3f",
	"./nav_tray_icons/Procedures_Icon_Over.svg": "9e55",
	"./nav_tray_icons/Procedures_Icon_Up.svg": "d049",
	"./nav_tray_icons/Save State_Down.svg": "c327",
	"./nav_tray_icons/Save State_Over.svg": "95ca",
	"./nav_tray_icons/Save_State_Up.svg": "5148",
	"./nav_tray_icons/SpeciesTray_Icon.svg": "f430",
	"./nav_tray_icons/Spectra Icon_Down.svg": "f9f5",
	"./nav_tray_icons/Spectra Icon_Over.svg": "7d86",
	"./nav_tray_icons/Spectra Icon_Up.svg": "687e",
	"./nav_tray_icons/Stockroom Icon_Down.svg": "575f",
	"./nav_tray_icons/Stockroom Icon_Over.svg": "b27f",
	"./nav_tray_icons/Stockroom Icon_Up.svg": "3690",
	"./nav_tray_icons/Unknowns Icon_Down.svg": "2212",
	"./nav_tray_icons/Unknowns Icon_Over.svg": "0ecb",
	"./nav_tray_icons/Unknowns_Icon_Up.svg": "6f79",
	"./nav_tray_icons/add-24px.svg": "3040",
	"./nav_tray_icons/delete_forever-24px.svg": "9077",
	"./nav_tray_icons/edit-24px.svg": "78ca",
	"./pdf/BL logo - Lab Book.png": "b0c4",
	"./pdf/BeyondLabz_watermark.jpg": "9626",
	"./pdf/Logo Name Lab Book - Blue.svg": "b6ce",
	"./pdf/PhosphorScreenOverlay.png": "6dd9",
	"./site_icons/ScreenCap_Down_36dp.svg": "bfe3",
	"./site_icons/ScreenCap_Over_36dp.svg": "5ad6",
	"./site_icons/ScreenCap_Up_36dp.svg": "7f28",
	"./site_icons/delete_forever-24px.svg": "08ee",
	"./site_icons/keyboard_arrow_left-24px.svg": "6be6",
	"./site_icons/user_symbol.svg": "6456",
	"./spinner.gif": "6324",
	"./splash/splash.jpg": "1bba"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";